export class  User {
    id: any;
    user_id: any;
    name: any;
    lastname: null;
    nationality: null;
    cellphone: null;
    document: null;
    document_type: null;
    birthday: string;
    sexo: null;
    email: string;
    address: null;
    province: null;
    city: null;
    country: null;
    image: null;
    active: 0;
    notificationPreviusFlight: 0;
    notificationPromotion: 0;
    observations: any;

    constructor(user?){
        user = user || {};
        this.id = user.id || 0;
        this.user_id = user.user_id || 0;
        this.name = user.name || '';
        this.lastname = user.lastname || null;
        this.nationality = user.lastname || null;
        this.cellphone = user.cellphone || null;
        this.document =  user.document || null;
        this.document_type =  user.document_type || null;
        this.birthday =  user.birthday || null;
        this.sexo =  user.sexo || null;
        this.email =  user.email || null;
        this.address =  user.address || null;
        this.province =  user.province || null;
        this.city = user.city || null;
        this.country = user.country || null;
        this.image = user.image || null;
        this.active = user.active || 0;
        this.notificationPreviusFlight = user.notificationPreviusFlight || 0;
        this.notificationPromotion = user.notificationPromotion || 0;
        this.observations = user.observations || null;
    }
}
